import React from 'react';
import './BtnRemove.styles.scss';

const BtnRemove = ({ OnClick }) => {
	return (
		<button onClick={OnClick} type="button" className="btn-red">
			<span className="material-symbols-outlined">delete_forever</span>
		</button>
	);
};

export default BtnRemove;
